<template>
  <div class="home">
    <order-search></order-search>
    <div class="container">
      <manager-decks></manager-decks>
    </div>
    <div class="container" v-if="$auth.check(['admin', 'dispatcher'])">
      <partner-request-list></partner-request-list>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import OrderSearch from '@/admin/components/OrderSearch.vue';
import PartnerRequestList from '@/admin/components/PartnerRequestList.vue';
import ManagerDecks from '@/admin/components/decks/ManagerDecks.vue';


export default {
  name: 'home',
  components: {
    OrderSearch,
    PartnerRequestList,
    ManagerDecks,
  },
};
</script>
